import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { DISPLAY_PRODUCT_IMAGE_DIMENSION } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/DisplayCollectionPromo/DisplayStickyActionBanner";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
import styled, { keyframes } from "styled-components";
var AddToCartAnimationBase = function(param) {
    var onAnimationComplete = param.onAnimationComplete, displayProductImageUrl = param.displayProductImageUrl;
    var isSSR = useIsSSR();
    React.useEffect(function() {
        var timeout = setTimeoutIfPossible(function() {
            onAnimationComplete();
        }, 3000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        onAnimationComplete
    ]);
    return /*#__PURE__*/ _jsxs(AnimationContainer, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(ProductImage, {
                src: optimizeImageUrl({
                    url: displayProductImageUrl
                }, isSSR, {
                    width: DISPLAY_PRODUCT_IMAGE_DIMENSION,
                    height: DISPLAY_PRODUCT_IMAGE_DIMENSION
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 12
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "NAVi4w",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Added to bag!"
                        }
                    ]
                })
            })
        ]
    });
};
export var AddToCartAnimation = observer(AddToCartAnimationBase);
var fadeIn = keyframes([
    "0%{opacity:0;transform:translateY(20px);}100%{opacity:1;transform:translateY(0);}"
]);
var AnimationContainer = styled(Row).withConfig({
    componentId: "sc-141ab1c2-0"
})([
    "background-color:",
    ";position:sticky;z-index:5;bottom:",
    ";right:",
    ";max-height:",
    "px;width:360px;max-width:calc(100% - ",
    ");padding:",
    ";border:1px solid ",
    ";margin-left:auto;animation:",
    " 1s ease-in-out;"
], Core.surface.inverse, getSpacing(12), getSpacing(12), DISPLAY_PRODUCT_IMAGE_DIMENSION + 24, getSpacing("3x"), getSpacing(12), Core.border.muted, fadeIn);
var ProductImage = styled.img.withConfig({
    componentId: "sc-141ab1c2-1"
})([
    "max-height:",
    "px;max-width:",
    "px;width:",
    "px;height:",
    "px;"
], DISPLAY_PRODUCT_IMAGE_DIMENSION, DISPLAY_PRODUCT_IMAGE_DIMENSION, DISPLAY_PRODUCT_IMAGE_DIMENSION, DISPLAY_PRODUCT_IMAGE_DIMENSION);
